import React from 'react';

import { useTranslation } from '@lt/localization';
import { CurrencyFormat, Link } from '@lt/components';

// import { pushExploreLinkClicked } from 'src/routes/SeoApp/utils/gtmEvents';

import HighlightedText from '../HighlightedText';

import {
  NEAREST_DEPARTURES_OFFERS_INFO,
  NEAREST_DATES_OFFERS_INFO,
} from '../../constants';
import type { INearestOffersInfoBlock } from './types';

export const NearestOffersInfoBlock = (props: INearestOffersInfoBlock) => {
  const {
    result,
    departure,
    departureChanged,
    destinationChanged,
    dateChanged,
    isMobile,
  } = props;
  const { t } = useTranslation();

  return (
    <>
      {t('explore.hotels.showedTours')}
      {departureChanged && !!departure && (
        <>
          {` ${t('hotel.cigarette.mobile.from')}`}
          <HighlightedText data-testid={NEAREST_DEPARTURES_OFFERS_INFO}>
            {departure.nameForm2}
          </HighlightedText>
        </>
      )}
      {destinationChanged &&
        'destinations' in result &&
        result.destinations?.map(({ nameForm3, link }, index) => (
          <Link
            // onClick={() =>
            //   pushExploreLinkClicked({
            //     custom_params: {
            //       type: 'alternative',
            //     },
            //   })
            // }
            key={nameForm3}
            href={link}
          >
            {index === 0 ? ' ' : ', '}
            {nameForm3}
          </Link>
        ))}
      {dateChanged && 'date' in result && (
        <>
          {t('search.empty.night')}
          <HighlightedText data-testid={NEAREST_DATES_OFFERS_INFO}>
            {result.date.nameForm1}
          </HighlightedText>
        </>
      )}
      {isMobile ? <br /> : ' '}
      {`${t('filters.prices.from')} `}
      <CurrencyFormat value={result.minPrice} />
    </>
  );
};
